import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { Tag } from '@fiverr-private/data_display';
import { logger } from '@fiverr-private/obs';
import useIndustriesIdeas from './hooks/useIndustriesIdeas';
import classes from './index.module.scss';

export const getTagLink = (type, tag) => {
    if (!type || !tag) {
        logger.error(new Error(`Missing required params for tag pages per type: ${type} and tag: ${tag}`));
    }

    return pathfinder('logo_maker_buyer_ideas_page', {
        type,
        tag,
    });
};

const IndustriesIdeas = ({ industries = [] }) => {
    const { cuttedIndustries } = useIndustriesIdeas({ industries });

    return (
        <section className={classes.wrapper}>
            <div className={classes.container}>
                <h2 className={classes.title}>
                    <I18n k="logo_maker_perseus.buyer_landing_page.industries.title" />
                </h2>
                <div className={classes.tagsBox}>
                    {cuttedIndustries.map(({ tagName, tagId, tagType }) => (
                        <Tag key={tagId} size="sm" href={getTagLink(tagType, tagId)}>
                            <div className={classes.tagLabel}>{tagName}</div>
                        </Tag>
                    ))}
                    <Tag
                        size="sm"
                        variant="outline"
                        theme="dark"
                        href={pathfinder('logo_maker_discover_logo_ideas_page')}
                    >
                        <div className={classes.tagLabel}>
                            &#65122; <I18n k="logo_maker_perseus.buyer_landing_page.industries.discover_more" />
                        </div>
                    </Tag>
                </div>
            </div>
        </section>
    );
};

IndustriesIdeas.propTypes = {
    industries: [],
};

export default IndustriesIdeas;
